"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.SupplyAndDemandResponse = void 0;
const enums_1 = require("../enums");
const supply_and_demand_data_response_1 = require("./supply-and-demand-data.response");
class SupplyAndDemandResponse {
}
exports.SupplyAndDemandResponse = SupplyAndDemandResponse;
//# sourceMappingURL=supply-and-demand.response.js.map